import { render, staticRenderFns } from "./RekapHasilKonsultasi.vue?vue&type=template&id=f5cff928"
import script from "./RekapHasilKonsultasi.vue?vue&type=script&lang=js"
export * from "./RekapHasilKonsultasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports